<template>
  <div class="main">
    <div class="wrapper">
      <div class="left">
        <ul class="nav">
          <li
            v-for="(item,index) in nav"
            @click="changeNews(item,index)"
            :class="currentIndex == index?'selected':''"
            :key="index"
          >
            <p>{{item.title}}</p>
            <i class="el-icon-arrow-right"></i>
          </li>
        </ul>
      </div>
      <div class="right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
      currentIndex: 0,
      nav: [
        { title: "机构简介", url: "jgjj" },
        { title: "章程", url: "zc" },
        { title: "理事会", url: "lsh" },
        { title: "法人登记证", url: "frdjz" },
        { title: "理事长简介", url: "lszjj" },
        { title: "专家顾问", url: "zjgw" },
      ]
    };
  },
  mounted() {
    this.changeIndex();
    Bus.$on("content",e=>{
      if(e=="zjgw"){
        this.changeIndex()
      }
    })
  },
  methods: {
    changeNews(item, index) {
      this.currentIndex = index;
      this.$router.push({ name: item.url });
    },
    changeIndex() {
      this.nav.some((item, index) => {
        if (
          item.url ==
          window.location.pathname
        ) {
          this.currentIndex = index;
          return true;
        }
        else{
          this.currentIndex = -1
        }
      });
    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
@color: #e76d30;
.main {
  width: 100%;

  .wrapper {
    width: 840px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    margin-bottom: 30px;

    .left {
      width: 200px;
      margin-right: 40px;
      margin-bottom: 30px;
      ul {
        li {
          width: 200px;
          height: 70px;
          line-height: 70px;
          margin-top: 6px;
          font-size: 16px;
          border: 1px #cccccc solid;
          position: relative;
          transition: 0.6s linear;
          display: flex;
          justify-content: space-between;
          align-items: center;
          p {
            color: #666;
            margin-left: 15px;
          }
          i {
            margin-right: 10px;
            color: #e67240;
          }
          &:hover {
            p {
              color: #fff;
            }
          }
          &:after {
            width: 200px;
            cursor: pointer;
            position: absolute;
            content: "";
            top: 100%;
            bottom: 0;
            right: 0;
            left: 0;
            z-index: -1;
            background: @color;
            transition: 0.3s all linear;
          }
          &:hover:after {
            top: 0;
            bottom: 0;
          }
        }
        .selected {
          background-color: @color;
          p {
            color: #fff;
          }
        }
      }
    }

    .right {
      flex: 1;
    }
  }
}
</style>